import React from "react";
import { Select } from "antd";
import { ThemeConfigFieldSchema } from "../../../config/theme-configure";

interface SelectInputProps {
  value?: string;
  onChange?: (value: string) => void;
  field?: ThemeConfigFieldSchema;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  value,
  onChange,
  field,
}: SelectInputProps) => (
  <Select value={value} onChange={onChange} options={field?.options ?? []} />
);
